import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ENV } from '../../env/environment';
import { UtiltiyProvider } from '../utiltiy/utiltiy';

@Injectable()
export class CrudProvider {
  baseUrl: any;
  constructor(public http: HttpClient,public utility:UtiltiyProvider) {
    console.log(ENV.API_URL,"-", ENV.DEV_URL );
    this.baseUrl = ENV.DEV_URL
    ; //  live
  }


 async  get(endpoint, tokenRequired) {
  tokenRequired = tokenRequired == "false"?false:true;
  let headers = await this.getHeaders(tokenRequired);
    return new Promise((resolve, reject) => {
      this.http.get(this.baseUrl + endpoint, { headers: headers }).subscribe(data => {
        resolve(data);
      }, err => {
        reject(err);
        console.log("ERER:", err);
      });
    });
  }

 async delete(endpoint, tokenRequired) {
  tokenRequired = true;
  let headers = await this.getHeaders(tokenRequired);
    return new Promise((resolve, reject) => {
      this.http.delete(this.baseUrl + endpoint, { headers: headers }).subscribe(data => {
        resolve(data);
      }, err => {
        reject(err);
        console.log("ERER:", err);
      });
    });
  }
  

  async post(endpoint, tokenRequired, payload) {
    tokenRequired = true;
    let headers = await this.getHeaders(tokenRequired);
    return new Promise((resolve, reject) => {
      this.http.post(this.baseUrl + endpoint, payload, { headers: headers }).subscribe(data => {
        resolve(data);
      }, err => {
        reject(err);
        console.log("ERER:", err);
      });
    });
  }

  async put(endpoint, tokenRequired, payload) {
    tokenRequired = true;
    let headers = await this.getHeadersUrlEncoded(tokenRequired);
    return new Promise((resolve, reject) => {
      this.http.put(this.baseUrl + endpoint,  payload, {headers: headers}).subscribe(data => {
        resolve(data);
      }, err => {
        reject(err);
        console.log("ERER:", err);
      });
    });
  }
  async putWithourForm(endpoint, tokenRequired, payload) {
    tokenRequired = true;
    let headers = await this.getHeaders(tokenRequired);
    return new Promise((resolve, reject) => {
      this.http.put(this.baseUrl + endpoint,  payload, {headers: headers}).subscribe(data => {
        resolve(data);
      }, err => {
        reject(err);
        console.log("ERER:", err);
      });
    });
  }

  async generateToken() {
    let token = await this.utility.getStorage("token");
    return token;
  

  }

  async getHeaders(tokenRequired) {
    if(tokenRequired){
      let token = await this.utility.getStorage("token");
      let headers = new HttpHeaders({
        'Authorization': "Bearer "+token
      });
     
      return headers;
    }else{
      return {};
    }
  }

  async getHeadersUrlEncoded(tokenRequired) {
    if(tokenRequired){
      let token = await this.utility.getStorage("token");
      let headers = new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
        'Authorization': "Bearer "+token
      });
     
      return headers;
    }else{
      let headers = new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
      });
      return headers;
    }
  }

}


// WEBPACK FOOTER //
// ./src/providers/crud/crud.ts